export default __webpack_public_path__ + "static/image-2844adcaf300834d72d2783b818d7b56.png";